import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { SummaryList } from './SummaryList';
import { routePaths } from 'components/Routes/data';
import { BankAccountDetails } from './BankAccountDetails';
import { PersonalDetails } from './PersonalDetails';
import { StatutoryContributions } from './StatutoryContributions';
import { NameMismatchBankAccount } from './NameMismatchBankAccount';
import { UnverifiedFailedBankAccount } from './UnverifiedFailedBankAccount';
import { IncorrectBankAccount } from './IncorrectBankAccount';
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbItemProps } from '@razorpay/blade/components';

const breadcrumbsUrlMap: Record<string, { title: string } & BreadcrumbItemProps> = {
  [routePaths.reports.missingInformation.root.split('/')[2]]: {
    title: 'Missing Information',
    href: routePaths.reports.missingInformation.root,
  },
  [routePaths.reports.missingInformation.bankAccount.split('/')[3]]: {
    title: 'Bank Account Details',
    href: routePaths.reports.missingInformation.bankAccount,
  },
  [routePaths.reports.missingInformation.statutory.split('/')[3]]: {
    title: 'Statutory Contributions',
    href: routePaths.reports.missingInformation.statutory,
  },
  [routePaths.reports.missingInformation.personal.split('/')[3]]: {
    title: 'Personal Details',
    href: routePaths.reports.missingInformation.personal,
  },
  [routePaths.reports.missingInformation.nameMismatch.split('/')[3]]: {
    title: 'Bank Account Name Mismatch',
    href: routePaths.reports.missingInformation.nameMismatch,
  },
  [routePaths.reports.missingInformation.unverifiedFailed.split('/')[3]]: {
    title: 'Unverified Bank Account Details',
    href: routePaths.reports.missingInformation.unverifiedFailed,
  },
  [routePaths.reports.missingInformation.incorrect.split('/')[3]]: {
    title: 'Incorrect Bank Account Details',
    href: routePaths.reports.missingInformation.incorrect,
  },
};

export const MissingInformation = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const crumbs = pathname.split('/');

  return (
    <Box padding='spacing.8'>
      <Breadcrumb marginBottom="spacing.5" color="neutral" size="medium">
        <BreadcrumbItem href="/reports">Reports</BreadcrumbItem>
        {crumbs
          .map((path) => {
            if (path) {
              const { title, ...props } = breadcrumbsUrlMap[path.toLowerCase()] || {};
              if (title) {
                return (
                  <BreadcrumbItem key={title} isCurrentPage={props.href.toLowerCase() === pathname.toLowerCase()} {...props}>
                    {title}
                  </BreadcrumbItem>
                );
              }
            }
            return null;
          })
          .filter(Boolean)}
      </Breadcrumb>
      <Switch>
        <Route exact path={routePaths.reports.missingInformation.root} component={SummaryList} />
        <Route
          exact
          path={routePaths.reports.missingInformation.bankAccount}
          component={BankAccountDetails}
        />
        <Route
          exact
          path={routePaths.reports.missingInformation.statutory}
          component={StatutoryContributions}
        />
        <Route
          exact
          path={routePaths.reports.missingInformation.personal}
          component={PersonalDetails}
        />
        <Route
          exact
          path={routePaths.reports.missingInformation.nameMismatch}
          component={NameMismatchBankAccount}
        />
        <Route
          exact
          path={routePaths.reports.missingInformation.unverifiedFailed}
          component={UnverifiedFailedBankAccount}
        />
        <Route
          exact
          path={routePaths.reports.missingInformation.incorrect}
          component={IncorrectBankAccount}
        />
      </Switch>
    </Box>
  );
};
